<template>
  <div class="program-page">
    <div v-for="(item, index) in programList" :key="index" class="item-div">
      <p class="item-title" v-html="item.title"></p>

      <div>
        <div class="second img-left">
          <img :src="imageSrc(item.num)" alt="">
          <div class="desc-div">
            <p class="desc" v-html="item.desc"></p>
          </div>
        </div>
        <ul>
          <li>
            <div><p>활동 시기 :&nbsp;</p></div>
            <div><p>{{item.date}}</p></div>
          </li>
          <li>
            <div><p>활동 장소 :&nbsp;</p></div>
            <div><p>{{item.place}}</p></div>
          </li>
          <li>
            <div><p>활동 대상 :&nbsp;</p></div>
            <div><p>{{item.target}}</p></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CsrDreamDungeon',
  data() {
    return {
      programList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.programList = [
        {
          num: 4,
          title: '꿈나무 던전탐험대',
          desc: '"꿈나무 던전탐험대"는 어린이집, 유치원 원아들을 전남드래곤즈의 홈경기장인 광양축구전용구장으로 초청하여 경기장을 둘러보며, 아이들에게 전남드래곤즈의 역사와 하는 일을 소개하는 프로그램입니다.<br>또한, 운동장 활동 시간을 제공함으로써 아이들에게 협동심, 자신감을 심어주고 축구와 전남드래곤즈에 대한 친숙함을 만들어줄 수 있는 프로그램입니다.',
          date: '매주 화요일10:30 ~ 12:00 (5월~11월)',
          place: '광양축구전용구장',
          target: '광양, 순천, 여수 지역 어린이집 및 유치원 (단체) / 1회 최대 인원 40명'
        },
      ];
    },

    imageSrc(num) {
      return require(`@/assets/img/club/program_0${num}.png`);
    },
  },
};
</script>

<style scoped>
.total-year-records {
  padding-right: 0;
}

.total-year-records table {
  min-width: auto;
}

.program-page .item-div .desc {
  word-break: normal;
}

@media (max-width: 959px) {
  .total-year-records table {
    min-width: 800px;
  }
}
</style>
